<template>
  <v-layout column>

    <v-dialog
      v-model="showAddContactDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      maxWidth="400"
    >
      <v-card>
        <v-card-title class="title justify-center"><v-icon color="accent" class="pr-2">person_add_alt_1</v-icon>Add Dispatch Contact</v-card-title>
        <v-card-text class="pl-4 pr-4">
          <v-text-field
            prepend-icon="business"
            v-model="addContactName"
            label="Company Dispatcher Name"
            placeholder="Company or Dispatcher Name"
            :error-messages="errors.first('dispatcherName', 'contact')"
            data-vv-as= "Company Dispatcher Name"
            data-vv-name="dispatcherName"
            data-vv-scope="contact"
            v-validate="{ required: true }">

          </v-text-field>
          <v-text-field class="mt-2"
            prepend-icon="phonelink_ring"
            v-model="addContactPhone"
            label="Phone Number to send SMS text messages"
            placeholder="Dispatcher Phone Number"
            :error-messages="errors.first('dispatcherPhone', 'contact')"
            data-vv-as= "Company Dispatcher Phone"
            data-vv-name="dispatcherPhone"
            data-vv-scope="contact"
            v-validate="{ required: true }">

          </v-text-field>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn color="accent" @click="addContact()" :disabled="errors.any('contact')">Add</v-btn>
          <v-btn color="primary" @click="cancelAddContact()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <v-container fluid class="pa-0 ma-0">
    <v-card expand flat class="full-card-desktop py-0 px-0">
      <v-alert
        :value="!hasProducerInfo"
        type="warning">
        This company is not set up as a {{$t('booked-load.producer').toLocaleLowerCase()}}
      </v-alert>

      <v-toolbar dense flat color="white" class="darken-1">
        <v-toolbar-title>Outside Dispatching</v-toolbar-title>
        <v-spacer/>
        <v-toolbar-items>
          <v-tabs color="darken-2" grow v-model="currentTab">
            <v-tab key="network" value="chicken">
              <v-layout column>
                <v-icon color="accent">hub</v-icon>
                LTN Network
              </v-layout>
            </v-tab>
            <v-tab key="contacts" value="waffles">
              <v-layout column>
                <v-icon color="accent">headset_mic</v-icon>
                Contacts
              </v-layout>
            </v-tab>

            <v-btn v-if="networkTabSelected && hasDispatchPerm" color="accent"
                   :disabled="!selected || loading" @click="sendInvite"
            >
              <v-layout column>
                <v-icon color="white">share</v-icon>
                Invite
              </v-layout>
            </v-btn>
            <v-btn v-if="contactTabSelected && hasDispatchPerm" color="accent"
                   @click="showAddContactDialog = true"
            >
              <v-layout column>
                <v-icon color="white">person_add_alt_1</v-icon>
                Add Contact
              </v-layout>
            </v-btn>
          </v-tabs>
        </v-toolbar-items>
      </v-toolbar>
      <v-tabs-items v-model="currentTab">
        <v-tab-item key="network" >
          <v-card-title>Your Preferred Carrier Network of LTN Accounts</v-card-title>

          <v-layout :column="$vuetify.breakpoint.smAndDown" align-baseline class="mr-1 mt-4">
            <v-flex>
              <v-autocomplete
                :loading="loading && !!search"
                :items="(search && search.length > 3) ? allTruckingCompanies : []"
                :search-input.sync="search"
                v-model="selected"
                clearable
                item-text="searchName"
                return-object
                class="mr-3"
                hide-no-data
                :disabled="!hasDispatchPerm"
                hide-details
                label="Search LTN Accounts to Add">

                <template slot="item" slot-scope="data">
                  <v-icon
                    :color="_.get(data, 'item.accountStatus.verified', null) ? 'green' : 'transparent'">
                    verified_user
                  </v-icon>
                  <span class="ml-1">{{data.item.searchName}}</span>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex>

              <template v-if="hideInactive">
                <v-btn @click="hideInactive = false"
                       :block="$vuetify.breakpoint.smAndDown"
                       class="mr-4" flat color="primary">
                  <v-icon class="mr-2">visibility</v-icon>
                  Show inactive
                </v-btn>
              </template>
              <template v-else>
                <v-btn @click="hideInactive = true"
                       :block="$vuetify.breakpoint.smAndDown"
                       class="mr-4" flat color="accent">
                  <v-icon class="mr-2">visibility_off</v-icon>
                  Hide inactive
                </v-btn>
              </template>

            </v-flex>
          </v-layout>

          <template v-if="members.length">
            <template v-if="$vuetify.breakpoint.smAndDown">
              <v-card v-for="member in members" :key="member.id" class="xs12 my-2">

                <v-card-title>
                  <v-layout column>
                    <h6 class="title">
                      {{member.companyName}}
                    </h6>
                  </v-layout>
                </v-card-title>

                <v-card-text>
                  <b>Member since:</b> {{member.memberSince | formatDate}}<br/>
                  <b>Verified since:</b> {{member.verifiedSince | formatDate}}<br/>

                  <v-layout row wrap>
                    <v-btn small color="accent" block
                           @click="removeMember(member.companyId)">
                      Remove
                    </v-btn>
                  </v-layout>
                </v-card-text>
              </v-card>
            </template>
            <v-data-table :headers="membersHeaders"
                          v-else
                          :pagination.sync="pagination"
                          hide-actions
                          disable-initial-sort
                          :items="members">
              <template slot="items" slot-scope="slotItems">
                <tr>
                  <td>
                    {{slotItems.item.companyName}}
                  </td>
                  <td>
                    {{slotItems.item.memberSince | formatDate}}
                  </td>
                  <td>
                    {{slotItems.item.verifiedSince | formatDate}}
                  </td>
                  <td>
                    <v-btn flat small color="accent"
                           @click="removeMember(slotItems.item.companyId)">
                      Remove
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </template>
          <div v-else>You have no Carriers in your Dispatching Network.</div>


          <v-layout align-baseline>
            <div class="title mr-3 mt-4">
              Received Invitations
            </div>
          </v-layout>

          <template v-if="received.length">
            <template v-if="$vuetify.breakpoint.smAndDown">
              <v-card v-for="receivedItem in received"
                      v-if="!requestInvitationId || receivedItem.id === requestInvitationId"
                      :key="receivedItem.id" class="xs12 my-2">

                <v-card-title>
                  <v-layout column>
                    <h6 class="title">
                      {{receivedItem.host.companyName}}
                    </h6>
                  </v-layout>
                </v-card-title>

                <v-card-text>
                  <b>Invited by:</b> {{receivedItem.invitedByDisplayName}}<br/>
                  <b>Status:</b>
                  <v-chip v-if="receivedItem.status === 'OFFERED'"
                          color="success" text-color="white">
                    {{receivedItem.status}}
                  </v-chip>
                  <v-chip v-else color="primary" text-color="white">
                    {{receivedItem.status}}
                  </v-chip>
                  <br/>

                  <v-layout row wrap>
                    <v-btn small color="primary"
                           block
                           :disabled="!hasDispatchPerm"
                           v-if="receivedItem.status === 'OFFERED'"
                           @click="acceptCDN(receivedItem.id)">
                      Accept
                    </v-btn>
                    <v-btn flat small color="accent"
                           block
                           :disabled="!hasDispatchPerm"
                           v-if="receivedItem.status === 'OFFERED'"
                           @click="removeCDN(receivedItem.id)">
                      Refuse
                    </v-btn>
                  </v-layout>
                </v-card-text>
              </v-card>
            </template>
            <v-data-table v-else
                          :headers="headers"
                          :pagination.sync="pagination"
                          disable-initial-sort
                          hide-actions
                          :items="received">
              <template slot="items" slot-scope="slotItems">
                <tr :bgcolor="slotItems.item.id === requestInvitationId ? '#88a2aa' : null" :class="{ 'selected-invitation':  slotItems.item.id === requestInvitationId}">
                  <td>
                    {{slotItems.item.host.companyName}}
                  </td>
                  <td>
                    {{slotItems.item.invitedByDisplayName}}
                  </td>
                  <td>
                    <v-chip v-if="slotItems.item.status === 'OFFERED'"
                            color="success" text-color="white">
                      {{slotItems.item.status}}
                    </v-chip>
                    <v-chip v-else color="primary" text-color="white">
                      {{slotItems.item.status}}
                    </v-chip>
                  </td>
                  <td>
                    <v-btn small :color="slotItems.item.id === requestInvitationId ? 'accent' : 'primary'"
                           :disabled="!hasDispatchPerm"
                           v-if="slotItems.item.status === 'OFFERED'"
                           @click="acceptCDN(slotItems.item.id)">
                      Accept
                    </v-btn>
                    <v-btn flat small color="accent"
                           :disabled="!hasDispatchPerm"
                           v-if="slotItems.item.status === 'OFFERED'"
                           @click="removeCDN(slotItems.item.id)">
                      Refuse
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

          </template>
          <div v-else>No invitations received to join other CDNs at this time.</div>

          <v-layout align-baseline>
            <div class="title mr-3 mt-4">
              Offered Invitations
            </div>
          </v-layout>

          <template v-if="offered.length">
            <template v-if="$vuetify.breakpoint.smAndDown">
              <v-card v-for="offeredItem in offered" :key="offeredItem.id" class="xs12 my-2">

                <v-card-title>
                  <v-layout column>
                    <h6 class="title">
                      {{offeredItem.invited.companyName}}
                    </h6>
                  </v-layout>
                </v-card-title>

                <v-card-text>
                  <b>Invited by:</b> {{offeredItem.invitedByDisplayName}}<br/>
                  <b>Status:</b>
                  <v-chip v-if="offeredItem.status === 'OFFERED'"
                          color="success" text-color="white">
                    {{offeredItem.status}}
                  </v-chip>
                  <v-chip v-else color="primary" text-color="white">
                    {{offeredItem.status}}
                  </v-chip>
                  <br/>

                  <v-layout row wrap>
                    <v-btn color="accent"
                           block
                           :disabled="!hasDispatchPerm"
                           v-if="offeredItem.status === 'OFFERED'"
                           @click="removeCDN(offeredItem.id)">
                      Remove
                    </v-btn>
                  </v-layout>
                </v-card-text>
              </v-card>
            </template>
            <v-data-table :headers="headers"
                          v-else
                          :pagination.sync="pagination"
                          hide-actions
                          disable-initial-sort
                          :items="offered">
              <template slot="items" slot-scope="slotItems">
                <tr>
                  <td>
                    {{slotItems.item.invited.companyName}}
                  </td>
                  <td>
                    {{slotItems.item.invitedByDisplayName}}
                  </td>
                  <td>
                    <v-chip v-if="slotItems.item.status === 'OFFERED'"
                            color="success" text-color="white">
                      {{slotItems.item.status}}
                    </v-chip>
                    <v-chip v-else color="primary" text-color="white">
                      {{slotItems.item.status}}
                    </v-chip>
                  </td>
                  <td>
                    <v-btn small color="accent" flat
                           :disabled="!hasDispatchPerm"
                           v-if="slotItems.item.status === 'OFFERED'"
                           @click="removeCDN(slotItems.item.id)">
                      Remove
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table >
          </template>
          <div v-else>No invitations to join your CDN at this time.</div>
        </v-tab-item>
        <v-tab-item key="contacts" >
          <v-card-title>Partner Dispatchers</v-card-title>
          <v-flex xs6>
            <v-list>
              <v-list-tile v-for="contact in company.dispatchContacts" :key="`companyDispatchContacts-${contact.id}`">
                <v-list-tile-action>
                  <v-icon color="accent">headset_mic</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ contact.name }}</v-list-tile-title>
                  <v-list-tile-sub-title class="font-italic">{{ contact.phone }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-avatar>
                  <v-btn flat fab small color="accent" @click="removeDispatchContact(contact)"

                  >
                    <v-icon>cancel</v-icon>
                  </v-btn>
                </v-list-tile-avatar>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
  </v-layout>
</template>

<script>
import _ from 'lodash';
import API from '@/api';
import { mapGetters } from 'vuex';
import * as types from '@/store/mutationTypes';
import { accountHasOfficePermission } from '@/store/permissions';
import {
  hasProducerInfo,
} from '@/types/models/company';
import LToolbarButton from '../../../components/ToolbarButton.vue';

export default {
  name: 'DispatchingInfoSection',
  components: { LToolbarButton },
  props: {
    company: {
      type: Object,
    },
  },
  data() {
    return {
      currentTab: 0,
      hideInactive: true,
      loading: false,
      select: null,
      selected: '',
      search: '',
      showAddContactDialog: null,
      addContactName: null,
      addContactPhone: null,
      cdns: [],
      pagination: {
        sortBy: 'created',
        descending: true,
        rowsPerPage: -1, // -1 for All
      },
      membersHeaders: [
        { text: 'Company Name', value: 'companyName' },
        { text: 'Member since', value: 'memberSince' },
        { text: 'Verified since', value: 'verifiedSince' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headers: [
        { text: 'Company Name', value: 'companyName' },
        { text: 'Invited by', value: 'companyName' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
    _() {
      return _;
    },
    ...mapGetters('companies', {
      allTruckingCompanies: 'allTruckingCompanies',
    }),
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    hasDispatchPerm() {
      const profileCompany = this.findCompanyAccount()(this.company.id);
      return this.isLtnAdmin || accountHasOfficePermission(profileCompany);
    },
    hasProducerInfo() {
      return hasProducerInfo(this.company);
    },
    offered() {
      return _.filter(_.get(this.cdns, 'offered', []), cdn => (this.hideInactive && cdn.status === 'OFFERED') || !this.hideInactive);
    },
    received() {
      return _.filter(_.get(this.cdns, 'received', []), cdn => (this.hideInactive && cdn.status === 'OFFERED') || !this.hideInactive);
    },
    members() {
      return _.get(this.cdns, 'members', []);
    },
    requestInvitationId() {
      return this.$route.query.inviteId;
    },
    requestedInvitation() {
      return _.chain(this.received)
        .filter(r => this.requestInvitationId)
        .find(r => r.id === this.requestInvitationId)
        .value();
    },
    networkTabSelected() {
      return this.currentTab === 0;
    },
    contactTabSelected() {
      return this.currentTab === 1;
    },
  },
  watch: {
    company() {
      this.loadCDNs();
    },
    showAddContactDialog(v) {
      console.log('showAddContactDialog ' + v);
    },
  },
  methods: {
    ...mapGetters('profiles', [
      'findCompanyAccount',
    ]),
    async acceptCDN(inviteId) {
      try {
        this.$store.commit(`applications/${types.START_LOADING}`);
        await API.dispatchers.acceptInvitation(inviteId);

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Accepted',
          timeout: 7000,
        });

        this.loadCDNs();
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async removeCDN(inviteId) {
      try {
        this.$store.commit(`applications/${types.START_LOADING}`);
        await API.dispatchers.refuseInvitation(inviteId);

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Removed',
          timeout: 7000,
        });

        this.loadCDNs();
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async removeMember(companyId) {
      try {
        this.$store.commit(`applications/${types.START_LOADING}`);
        await API.dispatchers.removeMember({
          companyId: this.company.id,
          memberCompanyId: companyId,
        });

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Removed',
          timeout: 7000,
        });

        this.loadCDNs();
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async sendInvite() {
      try {
        this.$store.commit(`applications/${types.START_LOADING}`);
        await API.dispatchers.inviteCompany({
          companyId: this.company.id,
          invitedCompanyId: this.selected.id,
        });

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Invitation sent',
          timeout: 7000,
        });

        this.selected = null;
        this.loadCDNs();
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async loadCDNs() {
      try {
        this.$store.commit(`applications/${types.START_LOADING}`);
        const apiResponse = await API.dispatchers.getCompanyCDNs({
          companyId: this.company.id,
        });

        this.cdns = apiResponse.data;
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async loadCompanies() {
      this.loading = true;
      await this.$store.dispatch('companies/getAllCompanies');
      this.loading = false;
    },
    refresh() {
      this.loadCompanies();
      this.loadCDNs();
      this.loadDispatchContacts();
    },
    async loadDispatchContacts() {
      console.log('read the dispatch contacts from API or something');
    },
    async removeDispatchContact(contact) {
      try {
        this.$store.commit(`applications/${types.START_LOADING}`);
        await API.company.deleteDispatchContact(this.company.id, contact.id);

        await this.$store.dispatch('applications/addLoading', [
          this.$store.dispatch('companies/getProfileCompany', { id: this.company.id }),
        ]);

        await this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Invitation sent',
          timeout: 3000,
        });

      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        if (closeDialog) {
          this.cancelAddContact();
        }
        this.$store.commit(`applications/${types.END_LOADING}`);
      }

    },
    async addContact() {
      const isValid = await this.$validator.validateAll('contact');
      if (!isValid) {
        return;
      }

      const body = {
        name: this.addContactName,
        phone: this.addContactPhone,
      };

      let closeDialog = false;
      try {
        this.$store.commit(`applications/${types.START_LOADING}`);
        await API.company.addDispatchContact(this.company.id, body);

        closeDialog = true;

        await this.$store.dispatch('applications/addLoading', [
          this.$store.dispatch('companies/getProfileCompany', { id: this.company.id }),
        ]);

        await this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Invitation sent',
          timeout: 3000,
        });

      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        if (closeDialog) {
          this.cancelAddContact();
        }
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    cancelAddContact() {
      this.addContactName = null;
      this.addContactPhone = null;
      this.showAddContactDialog = false;
    }
  },
  created() {
    this.refresh();
  },
};
</script>

<style scoped>
.selected-invitation {
  color: white;
}

.qb_tabs .v-tabs__wrapper {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/Companies/Sections/DispatchingInfoSection.vue